import { APIHandler } from "utilities/apiHandler";

import {
    PartnerAccountDisconnectResponse,
    PartnerInfo,
    PartnerRedirectInfoResponse,
    TakeoffSettingsEntity,
} from "./TakeoffSettings.api.types";

export interface ITakeoffSettingsHandler {
    get(partnerId: number): Promise<TakeoffSettingsEntity>;
    getPartner(partnerName: string): Promise<PartnerInfo>;
    getRedirectInfo(
        partnerId: number,
        windowParentUrl?: string,
        userId?: number,
    ): Promise<PartnerRedirectInfoResponse>;
    disconnect(partnerId: number): Promise<PartnerAccountDisconnectResponse>;
    disconnectUser(partnerId: number, userId: number): Promise<PartnerAccountDisconnectResponse>;
}

export class TakeoffSettingsHandler implements ITakeoffSettingsHandler {
    async get(partnerId: number): Promise<TakeoffSettingsEntity> {
        return await APIHandler(`/api/PartnerAccounts/Settings/?partnerId=${partnerId}`, {
            method: "GET",
            responseType: TakeoffSettingsEntity,
        });
    }

    async getRedirectInfo(
        partnerId: number,
        windowParentUrl?: string,
        userId?: number,
    ): Promise<PartnerRedirectInfoResponse> {
        return await APIHandler("/api/Partners/GetPartnerRedirectInfo", {
            method: "GET",
            data: { partnerId, windowParentUrl, userId },
            responseType: PartnerRedirectInfoResponse,
        });
    }

    async getPartner(partnerName: string): Promise<PartnerInfo> {
        return await APIHandler(`/api/Partners/GetPartnerByName`, {
            method: "GET",
            data: {
                partnerName: partnerName,
            },
            responseType: PartnerInfo,
        });
    }

    async disconnect(partnerId: number): Promise<PartnerAccountDisconnectResponse> {
        return await APIHandler(`/api/PartnerAccounts/?partnerId=${partnerId}`, {
            method: "DELETE",
            responseType: PartnerAccountDisconnectResponse,
        });
    }

    async disconnectUser(
        partnerId: number,
        userId: number,
    ): Promise<PartnerAccountDisconnectResponse> {
        return await APIHandler(`/api/PartnerAccounts/?partnerId=${partnerId}&userId=${userId}`, {
            method: "DELETE",
            responseType: PartnerAccountDisconnectResponse,
        });
    }
}
